/* eslint-disable import/no-unresolved */
import React from 'react';
import { Route, Switch, useRouteMatch } from 'react-router-dom';

import { PaymentBannerInfo } from 'assets/components';
import OrderCard from '../../screens/Card/CardOrder';
import Card from '../../screens/Card';
import CardAccounts from '../../screens/Card/CardAccounts';
import Cryptodraft from '../../screens/Card/Cryptodraft';
import LoadCardError from '../../screens/Card/LoadCardError';
import Loyalty from '../../screens/Card/Loyalty';
import CardSettings from '../../screens/Card/Settings';
import AddCardOrder from '../../screens/Card/CardOrder/addCardOrder';

const CardRouter = () => {
  const { path } = useRouteMatch();

  return (
    <Switch>
      <Route exact path={`${path}/`}>
        <OrderCard />
      </Route>
      <Route exact path={`${path}/details`}>
        <Card />
      </Route>
      <Route exact path={`${path}/error`}>
        <LoadCardError />
      </Route>
      <Route exact path={`${path}/cryptodraft`}>
        <Cryptodraft />
      </Route>
      <Route exact path={`${path}/settings`}>
        <CardSettings />
      </Route>
      <Route exact path={`${path}/order-card`}>
        <AddCardOrder />
      </Route>
      <Route exact path={`${path}/payment-banner-info`}>
        <PaymentBannerInfo />
      </Route>
      <Route exact path={`${path}/loyalty`}>
        <Loyalty />
      </Route>
      <Route exact path={`${path}/details/accounts`}>
        <CardAccounts />
      </Route>
    </Switch>
  );
};

export default CardRouter;
